import { api } from 'utility';
import {
  getCarTableListUrl,
  getCartableRequestListsUrl,
  getCreditUrl,
  getCaptchaServiceUrl,
  getUserContactUrl,
  getTransferFromWalletUrl,
  getTransferFromGuildUrl,
  getFileUrl,
  cartableGroupRequestsWithrequestId,
  getCollectionCardURL,
  cartableCancelRequest,
  getRDandDetaileInvoiceUrl,
  getExportMultipleTransfersCartableXlsx,
  getCarTableListRelatedUrl

} from 'URLs';
import { stringify } from 'qs';

class Services {
  /**
   * لیست حساب های چند امضایی
   */
  getCarTableList(params) {
    return api.post(getCarTableListUrl(), params).then((res) => res.data);
  }
  /**
   * لیست درخواست ها
   */
  getCartableRequestList(params) {
    return api.get(getCartableRequestListsUrl(), { params }).then((res) => res.data);
  }
  getCartableRequestListRestfull(params) {
    const url = getCarTableListRelatedUrl();
    return api
      .get(url, {
        params,
        paramsSerializer: (params) => {
          return stringify(params, { arrayFormat: 'repeat' });
        },
      })
      .then((res) => res.data);
  }


  getCartableRequestListRestfull(params) {
    const url = getCarTableListRelatedUrl();
    return api.get(url, {
      params,
      paramsSerializer: params => {
        return stringify(params, { arrayFormat: 'repeat' })
      }
    }).then((res) => res.data);
  }

  getCredit() {
    return api.get(getCreditUrl()).then((res) => res.data.result);
  }

  getCaptcha() {
    return api.get(getCaptchaServiceUrl()).then((res) => res.data);
  }
  checkContact(data) {
    return api.post(getUserContactUrl(), data).then((res) => res.data);
  }
  transferCreditContactWithWallet(cartableId, data) {
    return api.post(getTransferFromWalletUrl(cartableId), data).then((res) => res.data);
  }
  transferCreditContactWitGuild(cartableId, data) {
    return api.post(getTransferFromGuildUrl(cartableId), data).then((res) => res.data);
  }

  async exportMultipleTransferXls(id, params) {
    let paramData = {
      'type': params
    }
    return api.post(getExportMultipleTransfersCartableXlsx(id), {}, {
      responseType: 'blob',
      params: { ...paramData, forceSave: false },
    }).then((res) => res.data);
  }
  /**
  * درخواست فایل گزارش
  */
  async reportGroupRequest(requestId) {
    return api.post(cartableGroupRequestsWithrequestId(requestId)).then((res) => res.data);
  }
  /**
  * دریافت فایل گزارش
  */
  async reportGroupRequestReciveFile(requestId) {
    return api.get(cartableGroupRequestsWithrequestId(requestId)).then((res) => res.data.result);
  }
  /**
* دریافت فایل خروجی
*/
  async getFile(params) {
    return api.get(getFileUrl(), {
      responseType: 'blob',
      params: { ...params, forceSave: false },
    }).then((res) => res.data);
  }
  /**
   * 
   * کارت جمع
   */
  async requestCollectionCard(requestId) {
    return api.get(getCollectionCardURL(requestId)).then((res) => res.data.result);
  }

  /**
   *
   * لغو درخواست
   */
  async cartableCancelRequest(requestId) {
    return api.post(cartableCancelRequest(requestId)).then((res) => res.data.result);
  }

/**
 * دریافت اطلاعات و جزییات فاکتور
 * 
 */
async getInvoiceDetails(invoiceId) {
  return api.get(getRDandDetaileInvoiceUrl(invoiceId)).then((res) => res.data);
}
}

export default new Services();
